<template>
  <RegisterContainer>
    <div>
      <header class="form-header mb-4">
        <h2 class="title-text">What can we help you with today?</h2>
      </header>

      <div class="d-flex flex-column" style="gap: 16px">
        <TruformeOption @click="setReason('glp')" :selected="reason === 'glp'">
          <template #title> Weight Loss </template>
          <template #subtitle> Ozempic, Wegovy, Victoza, Mounjaro </template>
          <template #body>New prescriptions, switches and renewals</template>
        </TruformeOption>
        <!-- @click="setReason('ed')" -->
        <TruformeOption :selected="reason === 'ed'" disabled>
          <template #title>
            Erectile Dysfunction <v-chip label small color="success">Coming soon!</v-chip>
          </template>
          <template #subtitle> </template>
          <template #body>New prescriptions, switches and renewals</template>
        </TruformeOption>
      </div>
    </div>
  </RegisterContainer>
</template>
<style lang="scss" scoped>
.form-header {
  padding: 0px !important;
}

@media all and (max-width: 768px) {
  .form-header {
    .title-text {
      font-size: 1.3rem !important;
    }
  }
}
</style>
<script lang="ts">
import RegisterContainer from '../components/RegisterContainer.vue';
import TruformeOption from '../components/Truforme/TruformeOption.vue';

export default {
  name: 'TruformeLanding',
  components: {
    RegisterContainer,
    TruformeOption,
  },
  computed: {
    completed() {
      return !!this.reason;
    },
    reason() {
      return this.$store.state.registration.reasonForVisit;
    },
  },
  methods: {
    onNextClick() {},
    setReason(reason) {
      this.$store.commit('setRegistration', { reasonForVisit: reason });
    },
  },
  mounted() {
    this.$store.commit('setOnNextClick', () => {
      if (this.isPageflowV2) {
        this.$emit('next');
      } else {
        this.$router.push({ name: this.$store.getters.nextFlowRoute(this.$route.name) });
      }
    });
  },
};
</script>
